import { DashboardKpis, DashboardSnapshot } from '../models/dashboard.model';

/**
 * Indicadores do período. A API nova devolve `kpis`; a antiga não, e o painel segue funcionando
 * com os campos do snapshot anterior:
 *
 * | kpis            | snapshot antigo                |
 * |-----------------|--------------------------------|
 * | revenue         | invoices.totalAmount           |
 * | salesInvoices   | invoices.salesAuthorized       |
 * | previousRevenue | null (sem variação)            |
 * | orders          | orders.total                   |
 * | ordersToInvoice | orders.received + orders.sent  |
 * | ordersCancelled | orders.cancelled               |
 * | previousOrders  | null (sem variação)            |
 *
 * O período anterior fica sempre null no fallback: a API antiga não manda `firstActivityAt`, então
 * não há como saber se a empresa (ou o canal) existia no período anterior inteiro, e uma base
 * incompleta daria uma variação enganosa. Sem base verificável, sem variação.
 */
export function kpisFromSnapshot(snapshot: DashboardSnapshot | null | undefined): DashboardKpis | undefined {
  if (!snapshot) return undefined;
  if (snapshot.kpis) return snapshot.kpis;
  return {
    revenue: snapshot.invoices?.totalAmount ?? 0,
    salesInvoices: snapshot.invoices?.salesAuthorized ?? 0,
    previousRevenue: null,
    orders: snapshot.orders?.total ?? 0,
    ordersToInvoice: (snapshot.orders?.received ?? 0) + (snapshot.orders?.sent ?? 0),
    ordersCancelled: snapshot.orders?.cancelled ?? 0,
    previousOrders: null,
  };
}
